import { HTMLAttributes } from "react"

export default function AmazonLightsail(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="80px"
      height="80px"
      viewBox="0 0 80 80"
      version="1.1"
    >
      <title>Icon-Architecture/64/Arch_Amazon-Lightsail_64</title>
      <desc>Created with Sketch.</desc>
      <defs>
        <linearGradient
          x1="0%"
          y1="100%"
          x2="100%"
          y2="0%"
          id="linearGradient-1"
        >
          <stop stopColor="#C8511B" offset="0%"></stop>
          <stop stopColor="#FF9900" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g
        id="Icon-Architecture/64/Arch_Amazon-Lightsail_64"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Icon-Architecture-BG/64/Compute" fill="url(#linearGradient-1)">
          <rect id="Rectangle" x="0" y="0" width="80" height="80"></rect>
        </g>
        <path
          d="M32,41 L35,41 L35,39 L32,39 L32,41 Z M26,41 L29,41 L29,39 L26,39 L26,41 Z M20,41 L23,41 L23,39 L20,39 L20,41 Z M14,41 L17,41 L17,39 L14,39 L14,41 Z M59.627,47.412 L61.943,46.64 L59.627,45.868 L58.855,43.553 L58.084,45.868 L55.769,46.64 L58.084,47.412 L58.855,49.727 L59.627,47.412 Z M36.902,50.138 L36.13,52.454 L33.814,53.226 L36.13,53.997 L36.902,56.313 L37.674,53.997 L39.989,53.226 L37.674,52.454 L36.902,50.138 Z M36.902,25.258 L36.13,27.573 L33.814,28.345 L36.13,29.117 L36.902,31.433 L37.674,29.117 L39.989,28.345 L37.674,27.573 L36.902,25.258 Z M40.586,39.933 C44.257,42.338 46.837,47.031 47.9,53.252 C49.946,50.57 53.206,45.433 53.206,39.933 C53.206,34.459 50.325,29.647 47.907,26.573 C46.849,32.814 44.264,37.522 40.586,39.933 L40.586,39.933 Z M38.089,40.852 C37.722,40.694 37.483,40.333 37.483,39.933 C37.483,39.533 37.722,39.171 38.089,39.014 C42.459,37.14 45.426,31.705 46.228,24.104 C46.269,23.712 46.537,23.38 46.912,23.258 C47.286,23.135 47.699,23.246 47.964,23.539 C50.669,26.533 55.206,32.644 55.206,39.933 C55.206,47.676 49.663,54.432 47.964,56.318 C47.771,56.532 47.499,56.648 47.221,56.648 C47.117,56.648 47.014,56.632 46.912,56.6 C46.536,56.478 46.268,56.146 46.227,55.753 C45.424,48.157 42.458,42.725 38.089,40.852 L38.089,40.852 Z M67,40 C67,52.682 56.683,63 44,63 C32.553,63 22.756,54.46 21.212,43.135 L23.194,42.865 C24.604,53.204 33.548,61 44,61 C55.579,61 65,51.58 65,40 C65,28.42 55.579,19 44,19 C33.861,19 25.175,26.226 23.346,36.181 L21.379,35.819 C23.383,24.915 32.896,17 44,17 C56.683,17 67,27.318 67,40 L67,40 Z"
          id="Amazon-Lightsail-Icon_64_Squid"
          fill="#FFFFFF"
        ></path>
      </g>
    </svg>
  )
}
